import React, { useState } from 'react';
import { Modal, Row, Col } from 'react-bootstrap';
import "./LoginModal.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faBuilding, faLock } from '@fortawesome/free-solid-svg-icons';


const LoginModal = ({ show, handleClose }) => {
//   const [show, setShow] = useState(true); // Show modal by default

//   const handleClose = () => setShow(false);

  const redirectToLogin = (type) => {
    if (type === 'business') {
      window.location.href = 'https://podd.robo.secureinternetbank.com/ebc_ebc1151/Login/271070924  ';
    } else if (type === 'personal') {
      window.location.href ='https://podd.robo.secureinternetbank.com/PBI_PBI1151/Login/271070924';
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered dialogClassName="gn-login-modal">
      <Modal.Header closeButton>
        <Modal.Title>Secure account access</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="modal-intro">Choose how you’d like to sign in.</p>
        <Row className="g-3">
          <Col md={6}>
            <button className="login-card" onClick={() => redirectToLogin('personal')}>
              <div className="login-icon personal">
                <FontAwesomeIcon icon={faUser} />
              </div>
              <div className="login-content">
                <h5 className="login-title">Personal Banking</h5>
                <p className="login-desc">Checking, savings and e‑banking for individuals.</p>
                <span className="login-cta">Continue →</span>
              </div>
            </button>
          </Col>
          <Col md={6}>
            <button className="login-card" onClick={() => redirectToLogin('business')}>
              <div className="login-icon business">
                <FontAwesomeIcon icon={faBuilding} />
              </div>
              <div className="login-content">
                <h5 className="login-title">Business Banking</h5>
                <p className="login-desc">Accounts and services for your business.</p>
                <span className="login-cta">Continue →</span>
              </div>
            </button>
          </Col>
        </Row>
        <div className="login-actions">
          <a className="btn btn-gn-secondary me-2" href="/DirectDeposit">Direct deposit</a>
          <a className="btn btn-gn-primary" href="/OnlineBanking">Online banking</a>
        </div>
        <div className="login-help">
          <span className="lock">
            <FontAwesomeIcon icon={faLock} /> Your info is protected
          </span>
          <a href="/privacy" className="help-link">Privacy</a>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default LoginModal;
